/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { periodMeasureUnitEnumSchema } from "./periodMeasureUnitEnumSchema.ts";

export const organizationSubscriptionSchema = z
	.object({
		target_program: z.uuid().nullish(),
		brand: z.string().max(63).optional(),
		title: z.string().max(255).optional(),
		subtitle: z.string().max(255).optional(),
		description: z.string().optional(),
		benefits: z.array(z.string()),
		price_per_period: z
			.string()
			.regex(/^-?\d{0,8}(?:\.\d{0,2})?$/)
			.optional(),
		period: z.int().min(1).max(32767).optional(),
		period_measure_unit: periodMeasureUnitEnumSchema.optional().describe("* `month` - Месяц\n* `day` - День\n* `hour` - Час"),
		discount_percent: z
			.string()
			.regex(/^-?\d{0,3}(?:\.\d{0,2})?$/)
			.optional(),
		badge: z.string().max(127).optional(),
		cta: z.string().max(63).optional(),
		logo_url: z
			.string()
			.max(1024)
			.regex(/(?:png|jpg|jpeg|webp|svg|ai)$/)
			.nullable(),
		background_gradient: z.string().max(255).optional(),
		accent_color: z.string().max(15).optional(),
	})
	.describe("Описание конфигурации подписки организации.");
